export type OptionDescription<T> = {
  id: T;
  value: any;
  viewValue: string;
  [key: string]: any;
};
